<div class="filter-floors py-2">
  <div class="modal-main">
    <div class="header">
      <div class="d-flex flex-row justify-content-between my-1">
        <ng-container *ngIf="
            stepper === 1 && filter?.filterType === CONSTANTS.BUILDING_LISTING
          ">
          <div class="col-1 pointer-cursor">
            <img src="/assets/svg/ico-chevron-back-outline.svg" class="back-navigation pointer-cursor"
              (click)="closeDialog()" role="button" />
          </div>
        </ng-container>
        <ng-container *ngIf="
            stepper === 1 && filter?.filterType === CONSTANTS.FLOOR_MANAGEMENT
          ">
          <div class="col-1"></div>
        </ng-container>
        <ng-container *ngIf="stepper === 2 || stepper === 3">
          <div class="col-1">
            <img src="/assets/svg/ico-chevron-back-outline.svg" class="back-navigation pointer-cursor"
              (click)="navigateBack()" role="button" />
          </div>
        </ng-container>
        <div>
          <p class="modal-title text-center">
            {{ 'FILTER_UNITS' | translate }}
          </p>
        </div>
        <div class="col-1 text-right">
          <img src="/assets/svg/ico-hamburger-close.svg" class="pointer-cursor" (click)="closeDialog()" />
        </div>
      </div>
      <ng-container *ngIf="stepper === 1">
        <div class="row my-4 mx-3 pt-1">
          <div class="col-4"></div>
          <div class="col-4">
            <p class="text-center heading1">
              {{ 'FILTER_BY' | translate }}
            </p>
          </div>
          <div class="col-4" role="button" (click)="resetFilter(CONSTANTS.RESET_ALL)">
            <p class="text-right" [ngClass]="{
                'reset-btn':
                  filter.floorsSelected.length + filter.wingsSelected.length ===
                  0,
                'reset-btn-active':
                  filter.floorsSelected.length + filter.wingsSelected.length > 0
              }">
              {{ 'RESET' | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="stepper === 2">
        <div class="row my-4 mx-3 pt-1">
          <div class="col-4"></div>
          <div class="col-4">
            <p class="text-center heading1">
              {{ 'WING' | translate }}
            </p>
          </div>
          <div class="col-4" role="button" (click)="resetFilter(CONSTANTS.WINGS)">
            <p class="text-right" [ngClass]="{
                'reset-btn': filter.wingsSelected.length === 0,
                'reset-btn-active': filter.wingsSelected.length > 0
              }">
              {{ 'RESET' | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="stepper === 3">
        <div class="row my-4 mx-3 pt-1">
          <div class="col-4"></div>
          <div class="col-4">
            <p class="text-center heading1">
              {{ 'FLOORS' | translate }}
            </p>
          </div>
          <div class="col-4" role="button" (click)="resetFilter(CONSTANTS.FLOORS)">
            <p class="text-right" [ngClass]="{
                'reset-btn': filter.floorsSelected.length === 0,
                'reset-btn-active': filter.floorsSelected.length > 0
              }">
              {{ 'RESET' | translate }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="stepper === 1">
      <div class="scroll-container mx-3 mb-3">
        <div class="row py-2 filter-item pointer-cursor top-element" (click)="changeStep(CONSTANTS.WING)">
          <div class="ml-3 text-center d-flex flex-row justify-content-end align-items-center">
            <img src="assets/svg/ico-direction.svg" class="icon" />
          </div>
          <div class="col-8 pl-3 text-item d-flex flex-column justify-content-center">
            <p class="item-title">
              {{ 'WING' | translate }}
            </p>
            <p class="item-description ellipsis mb-0">
              <app-with-tooltip [showHelpCursor]="true">
               
                <ng-container *ngFor="
                    let wingsSelect of filter?.wingsSelected;
                    let last = last
                  ">
                  {{ wingsSelect ? wingsSelect : notSpecified 
                  }}
                  {{ !last ? ", " : "" }}
                </ng-container>
              </app-with-tooltip>
            </p>
          </div>

          <div class="col mr-3 text-right d-flex flex-row justify-content-end align-items-center pointer-cursor"
            role="button">
            <img src="assets/svg/ico-chevron-forward-outline.svg" />
          </div>
        </div>

        <div class="row py-2 filter-item pointer-cursor last-element" (click)="changeStep(CONSTANTS.FLOORS)">
          <div class="ml-3 text-center d-flex flex-row justify-content-end align-items-center">
            <img src="assets/svg/ico-floor-filter.svg" class="icon" />
          </div>
          <div class="col-8 pl-3 text-item d-flex flex-column justify-content-center">
            <p class="item-title">
              {{ 'FLOORS' | translate }}
            </p>
            <p class="item-description ellipsis mb-0">
              <app-with-tooltip [showHelpCursor]="true">
                {{ filter.floorsSelected }}
              </app-with-tooltip>
            </p>
          </div>

          <div class="col mr-3 text-right d-flex flex-row justify-content-end align-items-center pointer-cursor"
            role="button">
            <img src="assets/svg/ico-chevron-forward-outline.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="filter?.wings.length === 0 && stepper === 2">
      <div class="d-flex flex-column justify-content-center align-items-center h-50 my-171">
        <div class="text-container d-flex flex-column justify-content-center align-items-center">
          <div class="icon-container">
            <img src="assets/svg/ico-building-gray.svg" class="home-icon" />
          </div>

          <div class="text-center mt-3">
            <p>{{ 'NO_WING_IN_THIS_BUILDING' | translate }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="filter?.wings.length > 0 && stepper === 2">
      <div class="scroll-container mx-3 mb-3">
        <div class="row py-2 filter-item pointer-cursor" *ngFor="
            let wing of filter?.wings | sortedProperty : 'wingName';
            let i = index
          " [ngClass]="{
            'top-element': i === 0 && filter?.wings.length !== 1,
            'last-element':
              i === filter?.wings.length - 1 && filter?.wings.length !== 1,
            'middle-element': i !== 0 && i !== filter?.wings.length - 1,
            'only-element': filter?.wings.length === 1
          }">
          <div class="ml-3 text-center d-flex flex-row justify-content-end align-items-center">
            <img src="assets/svg/ico-direction.svg" class="icon" />
          </div>
          <div class="col-8 pl-3 text-item d-flex flex-column justify-content-center">
            <p class="item-title">
              <app-with-tooltip [showHelpCursor]="true">
                {{ wing?.wingName || ("NOT_SPECIFIED" | translate) }}
              </app-with-tooltip>
            </p>
          </div>
          <div class="col mr-3 text-right d-flex flex-row justify-content-end align-items-center pointer-cursor"
            role="button" (click)="selectWing(wing?.wingName)">
            <img src="assets/svg/ico-circle.svg" *ngIf="wing?.wingState === CONSTANTS.NOT_SELECTED" />

            <img *ngIf="wing?.wingState === CONSTANTS.SELECTED" src="assets/svg/ico-checkmark-circle-outline.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="stepper === 3">
      <div class="scroll-container mx-3 mb-3">
        <div class="row py-2 filter-item pointer-cursor" *ngFor="
            let floor of filter?.floors | orderBy : ['floorName'] as filter;
            let i = index
          " [ngClass]="{
            'top-element': i === 0 && filter.length !== 1,
            'last-element': i === filter.length - 1 && filter.length !== 1,
            'middle-element': i !== 0 && i !== filter.length - 1,
            'only-element': filter?.length === 1
          }">
          <div class="ml-3 text-center d-flex flex-row justify-content-end align-items-center">
            <img src="assets/svg/ico-floor-filter.svg" class="icon" />
          </div>
          <div class="col-8 pl-3 text-item d-flex flex-column justify-content-center">
            <p class="item-title">
              <app-with-tooltip [showHelpCursor]="true">
                {{ floor?.floorName }}
              </app-with-tooltip>
            </p>
          </div>
          <div class="col mr-3 text-right d-flex flex-row justify-content-end align-items-center pointer-cursor"
            role="button" (click)="selectFloor(floor.floorId, floor?.floorName)">
            <img src="assets/svg/ico-circle.svg" *ngIf="floor?.floorState === CONSTANTS.NOT_SELECTED" />

            <img *ngIf="floor?.floorState === CONSTANTS.SELECTED" src="assets/svg/ico-checkmark-circle-outline.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row my-3 mx-3">
      <button class="btn btn-danger px-3 w-100 result-btn" type="button" tabindex="0" (click)="applyFilter()">
        {{ 'SEE_RESULTS' | translate }}
      </button>
    </div>
  </div>
</div>